import { measure } from 'constants/units';

import { nameInput, heightInput, IUserFormData } from '../types';

const { TALL_UNIT } = measure;

const NUMBERED_FIELDS = ['age', 'heightImperialFt', 'heightImperialIn', 'heightMetric', 'weight'];

export const getHeightFields = (t: (key: string) => string): heightInput[] => {
    return [
        {
            field: 'heightImperialFt',
            unit: TALL_UNIT.imperial.ft,
            min: 4,
            max: 7,
            label: t('account.profile.height'),
            placeholder: t('account.profile.height'),
            dataLocator: 'ftInput',
        },
        {
            field: 'heightImperialIn',
            unit: TALL_UNIT.imperial.in,
            min: 0,
            max: 11,
            label: t('account.profile.height'),
            placeholder: t('account.profile.height'),
            dataLocator: 'inInput',
        },
    ];
};

export const getNameFields = (t: (key: string) => string): nameInput[] => [
    {
        name: 'name',
        label: t('account.profile.firstName'),
        dataLocator: 'firstNameInput',
        placeholder: t('account.profile.firstName'),
    },
    {
        name: 'last_name',
        label: t('account.profile.lastName'),
        dataLocator: 'lastNameInput',
        placeholder: t('account.profile.lastName'),
    },
];

export const radioFields = [
    { name: 'female', label: 'account.profile.gender.female', dataLocator: 'genderFemaleRadio' },
    { name: 'male', label: 'account.profile.gender.male', dataLocator: 'genderMaleRadio' },
];

export const getUserUpdatedKeys = (userInitValues: IUserFormData, formValue: { [field: string]: string | number }) => {
    const changedKeys: string[] = [];

    Object.keys(userInitValues).forEach((key) => {
        if (NUMBERED_FIELDS.includes(key)) {
            if (Number(userInitValues[key as keyof IUserFormData]) !== Number(formValue[key])) {
                changedKeys.push(key);
            }
        } else {
            if (userInitValues[key as keyof IUserFormData] !== formValue[key]) {
                changedKeys.push(key);
            }
        }
    });

    return changedKeys;
};
